import {
  ProductCollection,
  BreadcrumbsSlice,
  ProductsSlice,
  MetaDataSlice,
  ProductCollectionSlice,
  OffersSlice,
} from '../../types';
import { MetaDataContext } from './types';

type Props = {
  data: {
    productCollection: ProductCollection;
  };
};

const getSlice = <T extends ProductCollectionSlice>(
  slices: ProductCollectionSlice[],
  type: string
): T | undefined =>
  Array.isArray(slices)
    ? slices.find((slice): slice is T => slice.__typename === type)
    : undefined;

export default ({ data }: Props, { t }: MetaDataContext) => {
  if (!data || !data.productCollection) {
    return {};
  }

  const { slices, indexable } = data.productCollection;
  const metaData = getSlice<MetaDataSlice>(slices, 'MetaDataSlice');
  const breadcrumb = getSlice<BreadcrumbsSlice>(slices, 'BreadcrumbsSlice');
  const products = getSlice<ProductsSlice>(slices, 'ProductsSlice');
  const offers = getSlice<OffersSlice>(slices, 'OffersSlice');

  if (!metaData) {
    return {};
  }
  const nodes = offers?.offers || products?.products;
  const noIndex = nodes?.length === 0 || indexable === false;
  const {
    title,
    description,
    hrefLang,
    image,
    url: metaUrls,
    pagination,
  } = metaData;
  const { current, next, prev } = metaUrls || {};

  const titleWithPagination =
    pagination && pagination.currentPage > 1
      ? t('meta', 'product-collection.paginated-title', {
          ...pagination,
          title,
        })
      : title;
  const descriptionWithPagination =
    pagination && pagination.currentPage > 1
      ? t('meta', 'product-collection.paginated-description', {
          ...pagination,
          description: description || '',
        })
      : description;

  return {
    title: titleWithPagination,
    description: descriptionWithPagination,
    canonical: noIndex ? undefined : current,
    noIndex,
    breadcrumb: breadcrumb && breadcrumb.items,
    openGraph: [
      {
        key: 'title',
        content: title,
      },
      {
        key: 'url',
        content: current,
      },
      {
        key: 'desc',
        content: descriptionWithPagination,
      },
      {
        key: 'type',
        content: 'product.group',
      },
      {
        key: 'image',
        content: image,
      },
    ],
    thumbnail: image,
    hrefLang,
    next,
    prev,
  };
};
